export const messages = {
  teamCreated: 'Team was successfully created',
  teamDeleted: 'Team was successfully deleted',
  userRole: 'Role was successfully edited',
  successResetPassword: 'Your password was successfully restored',
  passwordRestoreFail:
    'Password restore failed, are you connected to the internet?',
  successRegistration: 'Registration was completed successfully',
  deletedSuccessItemMessage: (message: string) =>
    `${message} was successfully deleted`
}

const AUTH_PATH = 'authentication/'
export const LOGIN_URL = `/${AUTH_PATH}login`
export const APPLICATIONS_URL = '/applications'
export const brokerRedirect = (token: string) =>
  `/apps/insurance/${token}/sales-panel`

export const MFA_AUTH_ENABLE = import.meta.env.VITE_APP_MFA_AUTH === 'true'
export const PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#%^])[A-Za-z\d@$!%*?&#%^]{10,}$/
